import React from 'react';
import { cn } from './cn';

/** Accessible switch. */
const Toggle = ({ checked, onChange, disabled, label, className, size = 'md', ...rest }) => {
  const dims =
    size === 'sm'
      ? { track: 'w-9 h-5', knob: 'w-4 h-4', on: 'translate-x-4' }
      : { track: 'w-11 h-6', knob: 'w-5 h-5', on: 'translate-x-5' };
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange && onChange(!checked)}
      className={cn(
        'relative inline-flex flex-shrink-0 items-center rounded-full transition-colors duration-150',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 focus-visible:ring-offset-2 focus-visible:ring-offset-card',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        dims.track,
        checked ? 'bg-accent' : 'bg-line-strong',
        className
      )}
      {...rest}
    >
      <span
        className={cn(
          'inline-block rounded-full bg-white shadow transform transition-transform duration-150 translate-x-0.5',
          dims.knob,
          checked && dims.on
        )}
      />
    </button>
  );
};

export default Toggle;
